// TODO: Migrate to PetitionQRCodeDownload from 'src/app/shared/components/qrcode'
import type React from 'react';

import { QRCodeDownload as QRCodeDownloadSunrise } from './components/QRCodeDownload';
import { usePetitionUrlQRCode } from './hooks/usePetitionUrlQRCode';

export const PetitionUrlQRCode: React.FC = () => {
	const { data } = usePetitionUrlQRCode();

	if (!data.shareAction) {
		return null;
	}

	const { ShareAction } = data.shareAction;

	return (
		<div className="mt-6">
			<ShareAction>
				<QRCodeDownloadSunrise
					slugOrId={data.slugOrId}
					displaySize={data.displaySize}
					displayType={data.displayType}
					downloadType={data.downloadType}
					descriptionText={data.descriptionText}
					downloadLinkText={data.downloadLinkText}
					downloadFilename={data.downloadFilename}
				/>
			</ShareAction>
		</div>
	);
};
